const PreferenceName = {
	showUnreadNotifications: 'showUnreadNotifications',
	monthsToAutoArchiveNotifications: 'monthsToAutoArchiveNotifications',
	collaborativeListsToShow: 'collaborativeListsToShow',
	communityReviewsToShow: 'communityReviewsToShow',
	showSmallJacket: 'showSmallJacket',
	conversationsToShow: 'conversationsToShow',
	conversationStatusView: 'conversationStatusView',
	collapsedLanes: 'collapsedLanes',
	laneStructure: 'laneStructure',
	preferred: 'preferred',
};

export default PreferenceName;
